import React from 'react';
import { Link } from 'react-router-dom';
import { TrendingUpIcon } from 'lucide-react';
export function Footer() {
  return <footer className="bg-slate-900 text-white mt-auto" data-id="element-75">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-76">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8" data-id="element-77">
          <div className="col-span-1 md:col-span-2" data-id="element-78">
            <div className="flex items-center gap-2 mb-4" data-id="element-79">
              <TrendingUpIcon className="text-blue-400" size={28} data-id="element-80" />
              <span className="text-xl font-bold" data-id="element-81">CryptoTopReviews</span>
            </div>
            <p className="text-slate-400 mb-4" data-id="element-82">
              Your trusted source for cryptocurrency reviews, ratings, and
              market intelligence.
            </p>
          </div>

          <div data-id="element-83">
            <h3 className="font-semibold mb-4" data-id="element-84">Quick Links</h3>
            <ul className="space-y-2" data-id="element-85">
              <li data-id="element-86">
                <Link to="/cryptocurrencies" className="text-slate-400 hover:text-white transition-colors" data-id="element-87">
                  Cryptocurrencies
                </Link>
              </li>
              <li data-id="element-88">
                <Link to="/exchanges" className="text-slate-400 hover:text-white transition-colors" data-id="element-89">
                  Exchanges
                </Link>
              </li>
              <li data-id="element-90">
                <Link to="/opportunities" className="text-slate-400 hover:text-white transition-colors" data-id="element-91">
                  Opportunities
                </Link>
              </li>
              <li data-id="element-92">
                <Link to="/social-media" className="text-slate-400 hover:text-white transition-colors" data-id="element-93">
                  Social Media
                </Link>
              </li>
            </ul>
          </div>

          <div data-id="element-94">
            <h3 className="font-semibold mb-4" data-id="element-95">Legal</h3>
            <ul className="space-y-2" data-id="element-96">
              <li data-id="element-97">
                <Link to="/terms-of-use" className="text-slate-400 hover:text-white transition-colors" data-id="element-98">
                  Terms of Use
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center" data-id="element-99">
          <p className="text-slate-400 text-sm" data-id="element-100">
            © {new Date().getFullYear()} CryptoTopReviews. All rights reserved.
          </p>
          <p className="text-slate-500 text-xs mt-2" data-id="element-101">
            <Link to="/terms-of-use" className="text-blue-400 hover:text-blue-300 font-semibold" data-id="element-102">
              Terms of Use & Disclaimer
            </Link>
          </p>
        </div>
      </div>
    </footer>;
}